import script from "./roles-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./roles-modal.vue?vue&type=script&setup=true&lang=js"

import "./roles-modal.vue?vue&type=style&index=0&id=bd445c4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd445c4c"]])

export default __exports__